import { render, staticRenderFns } from "./ModalContract.vue?vue&type=template&id=dde22e44&scoped=true"
import script from "./ModalContract.vue?vue&type=script&lang=js"
export * from "./ModalContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde22e44",
  null
  
)

export default component.exports